var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('th',[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('td',{style:(_vm.nameVal==''?'':'cursor:pointer;'),on:{"click":_vm.moveToLink}},[_vm._v(" "+_vm._s(_vm.nameVal)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }